import { Injectable, EventEmitter, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  @Output() eventEmitter : EventEmitter<any> = new EventEmitter();
  alertMessage = {confirmClass:'success', message: 'Some Message'}
  MyCallbackYes: () => void;
  MyCallbackNo: () => void;
  constructor() { }
  show(message: any,callBackYes: () => void,callBackNo: () => void) {
    this.MyCallbackYes = callBackYes
    this.MyCallbackNo = callBackNo

    this.eventEmitter.emit( { confirmClass: 'alert-warning', message: message } );
  }
  getEventEmitter() {
    return this.eventEmitter;
  }
  yes(){
    this.MyCallbackYes()
  }
  no(){
    this.MyCallbackNo()
  }
}
